/*
 * Rebuy renders its product boxes client-side. When a box's variant line repeats the product title exactly
 * (e.g. "Digital Instant-Read Thermometer" / "Digital Instant-Read Thermometer"), hide the duplicate line.
 * Re-checks whenever Rebuy renders or re-renders a widget, including variant changes.
 */
(function () {
  'use strict';

  var HIDDEN_CLASS = 'rebuy-variant-title--duplicate';

  function normalize(text) {
    return String(text || '').replace(/\s+/g, ' ').trim();
  }

  function check(block) {
    var title = block.querySelector('.rebuy-product-title');
    if (!title) return;
    var titleText = normalize(title.textContent);
    var candidates = new Set(block.querySelectorAll('.rebuy-variant-title'));
    // Rebuy templates vary; also consider plain text siblings after the title.
    for (var sibling = title.nextElementSibling; sibling; sibling = sibling.nextElementSibling) {
      candidates.add(sibling);
    }
    candidates.forEach(function (element) {
      if (element === title || element.contains(title)) return;
      // Never hide variant pickers, prices or buttons — only a plain text line.
      if (element.querySelector('select, button, input, a, [class*="price"]') || /price/.test(element.className)) return;
      var duplicate = titleText !== '' && normalize(element.textContent) === titleText;
      element.classList.toggle(HIDDEN_CLASS, duplicate);
    });
  }

  var scheduled = false;
  function scan() {
    scheduled = false;
    document.querySelectorAll('.rebuy-product-block').forEach(check);
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(scan);
  }

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var target = mutations[i].target;
      var element = target.nodeType === 1 ? target : target.parentElement;
      if (!element) continue;
      // Attributes are not observed, so this script's own class toggles never re-trigger it.
      if (element.closest('[data-rebuy-id], .rebuy-widget, .rebuy-product-block') ||
          (element.querySelector && element.querySelector('.rebuy-product-block'))) {
        schedule();
        return;
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });

  schedule();
})();
